import { useCallback, useEffect, useState } from 'react';
import { listCoupons, createCoupon, updateCoupon, deleteCoupon } from '../services/couponService';

export function useCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCoupons = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await listCoupons();
      setCoupons(data || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCoupons();
  }, [fetchCoupons]);

  const saveCoupon = useCallback(
    async (coupon) => {
      if (coupon._id) {
        await updateCoupon(coupon);
      } else {
        await createCoupon(coupon);
      }
      await fetchCoupons();
    },
    [fetchCoupons]
  );

  const removeCoupon = useCallback(
    async (id) => {
      await deleteCoupon(id);
      await fetchCoupons();
    },
    [fetchCoupons]
  );

  return { coupons, loading, error, refetch: fetchCoupons, saveCoupon, removeCoupon };
}
